import axios from "axios";

export const ACTIVE_ENV = "PROD";

export const isProd = ACTIVE_ENV === "PROD";
export const isTest = ACTIVE_ENV === "TEST";

// ─── WhatsApp group automation servers ────────────────────────────────────────
export const AUTOMATION_VM_URLS = {
  // aws9 / aws10 (thinkzone.in.net) were replaced by vm1 / vm2 (binadidi.info)
  // vm9: "https://aws9.thinkzone.in.net",
  // vm10: "https://aws10.thinkzone.in.net",
  vm1: "https://vm1.binadidi.info",
  vm2: "https://vm2.binadidi.info",
};

// Master server: send message, sync servers, message templates
export const AUTOMATION_MASTER_URL = AUTOMATION_VM_URLS.vm1;

// Group reports and chatbot (not yet available on the vm1 master)
// Group reports are on the vm1 master now; still here: getConversationReport
// and the chatbot.
export const AUTOMATION_DB_URL = "https://awsdb.thinkzone.in.net";

// VMs not listed in AUTOMATION_VM_URLS are skipped
const activeVms = (vms = Object.keys(AUTOMATION_VM_URLS)) =>
  vms.filter((vm) => AUTOMATION_VM_URLS[vm]);

// Builds { vm9: "<vm9 host>/<path>", ... } for the given VMs
export const getVmEndpoints = (path, vms) =>
  Object.fromEntries(
    activeVms(vms).map((vm) => [vm, `${AUTOMATION_VM_URLS[vm]}/${path}`]),
  );

// Builds [{ value: "vm1", label: "VM 1" }, ...] for VM dropdowns
export const getVmOptions = (vms) =>
  activeVms(vms).map((vm) => ({ value: vm, label: `VM ${vm.slice(2)}` }));

export const urlConfig = {
  prod: {
    LoginUrl: "https://tatvagyan.co.in/nipun/",
    NipunUrl: "https://nipunodisha.in/nipun/",
    ChatbotUrl: `${AUTOMATION_DB_URL}/chatbot`,
    // ChatbotUrl: "http://localhost:4000/chatbot"
  },
  test: {},
  local: {},
};

export const PROD_BOT_URL = "https://thinkzone.info/meta/";
export const TEST_BOT_URL = "https://tatvagyan.co.in/";
// export const LOCAL_CHATBOT_URL = `${AUTOMATION_DB_URL}/chatbot`;

export const LOCAL_CHATBOT_URL = "http://localhost:4000/chatbot"
export const PRAKASHAK_BASE_URL = "https://thinkzone.info/prakashak";

const getCurrentConfig = () => {
  const env =
    ACTIVE_ENV === "PROD" ? "prod" : ACTIVE_ENV === "TEST" ? "test" : "local";
  return urlConfig[env] || urlConfig.prod;
};

export const API_BASE_URL = getCurrentConfig().ChatbotUrl;
export const NIPUN_API_BASE_URL = getCurrentConfig().NipunUrl;

export const CHATBOT_URL = axios.create({
  baseURL: isProd ? API_BASE_URL : LOCAL_CHATBOT_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

export const PRAKASHAK_URL = axios.create({
  baseURL: PRAKASHAK_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});
